// extracted by mini-css-extract-plugin
export default {"remove":"fwF0AVdiC3PpJ1k"};